import { render, staticRenderFns } from "./StcvN_ItemsFinish.vue?vue&type=template&id=1f53f127"
import script from "./StcvN_ItemsFinish.vue?vue&type=script&lang=js"
export * from "./StcvN_ItemsFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports